export class GeoType {

    constructor(geoSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.codeStandardDocument = data.codeStandardDocument ?? null;
        this.geoSection = geoSection ?? null;
        this.massType = data.massType ?? null;
        this.effectiveCohesionCef = data.effectiveCohesionCef ?? null;
        this.effectiveInternalFrictionAngleFiEf = data.effectiveInternalFrictionAngleFiEf ?? null;
        this.poissonCoefficientNi = data.poissonCoefficientNi ?? null;
        this.overconsolidationRatioOcr = data.overconsolidationRatioOcr ?? null;
        this.bulkUnitWeightGamaCalcMethod = data.bulkUnitWeightGamaCalcMethod ?? null;
        this.bulkUnitWeightGama = data.bulkUnitWeightGama ?? null;
        this.bulkUnitWeightGamaGiven = data.bulkUnitWeightGamaGiven ?? null;
        this.minBulkUnitWeightGamaMinCalcMethod = data.minBulkUnitWeightGamaMinCalcMethod ?? null;
        this.minBulkUnitWeightGamaMin = data.minBulkUnitWeightGamaMin ?? null;
        this.minBulkUnitWeightGamaMinGiven = data.minBulkUnitWeightGamaMinGiven ?? null;
        this.dryUnitWeightGamaDCalcMethod = data.dryUnitWeightGamaDCalcMethod ?? null;
        this.dryUnitWeightGamaD = data.dryUnitWeightGamaD ?? null;
        this.dryUnitWeightGamaDGiven = data.dryUnitWeightGamaDGiven ?? null;
        this.specificGravityGs = data.specificGravityGs ?? null;
        this.unitWeightOfSolidsGamaSCalcMethod = data.unitWeightOfSolidsGamaSCalcMethod ?? null;
        this.unitWeightOfSolidsGamaS = data.unitWeightOfSolidsGamaS ?? null;
        this.unitWeightOfSolidsGamaSGiven = data.unitWeightOfSolidsGamaSGiven ?? null;
        this.minUnitWeightOfSolidsGamaSMinCalcMethod = data.minUnitWeightOfSolidsGamaSMinCalcMethod ?? null;
        this.minUnitWeightOfSolidsGamaSMin = data.minUnitWeightOfSolidsGamaSMin ?? null;
        this.minUnitWeightOfSolidsGamaSMinGiven = data.minUnitWeightOfSolidsGamaSMinGiven ?? null;
        this.saturatedUnitWeightGamaSatCalcMethod = data.saturatedUnitWeightGamaSatCalcMethod ?? null;
        this.saturatedUnitWeightGamaSat = data.saturatedUnitWeightGamaSat ?? null;
        this.saturatedUnitWeightGamaSatGiven = data.saturatedUnitWeightGamaSatGiven ?? null;
        this.submergedUnitWeightGamaSubCalcMethod = data.submergedUnitWeightGamaSubCalcMethod ?? null;
        this.submergedUnitWeightGamaSub = data.submergedUnitWeightGamaSub ?? null;
        this.submergedUnitWeightGamaSubGiven = data.submergedUnitWeightGamaSubGiven ?? null;
        this.minSubmergedUnitWeightGamaSubMinCalcMethod = data.minSubmergedUnitWeightGamaSubMinCalcMethod ?? null;
        this.minSubmergedUnitWeightGamaSubMin = data.minSubmergedUnitWeightGamaSubMin ?? null;
        this.minSubmergedUnitWeightGamaSubMinGiven = data.minSubmergedUnitWeightGamaSubMinGiven ?? null;
        this.hasBuoyancyEffectWhenUnderWater = data.hasBuoyancyEffectWhenUnderWater ?? null;
        this.degreeOfSaturationSrCalcMethod = data.degreeOfSaturationSrCalcMethod ?? null;
        this.degreeOfSaturationSr = data.degreeOfSaturationSr ?? null;
        this.degreeOfSaturationSrGiven = data.degreeOfSaturationSrGiven ?? null;
        this.moistureContentWCalcMethod = data.moistureContentWCalcMethod ?? null;
        this.moistureContentW = data.moistureContentW ?? null;
        this.moistureContentWGiven = data.moistureContentWGiven ?? null;
        this.plasticityIndexIpCalcMethod = data.plasticityIndexIpCalcMethod ?? null;
        this.plasticityIndexIp = data.plasticityIndexIp ?? null;
        this.plasticityIndexIpGiven = data.plasticityIndexIpGiven ?? null;
        this.porosityNCalcMethod = data.porosityNCalcMethod ?? null;
        this.porosityN = data.porosityN ?? null;
        this.porosityNGiven = data.porosityNGiven ?? null;
        this.voidRatioECalcMethod = data.voidRatioECalcMethod ?? null;
        this.voidRatioE = data.voidRatioE ?? null;
        this.voidRatioEGiven = data.voidRatioEGiven ?? null;
        this.effectiveGrainSizeD10 = data.effectiveGrainSizeD10 ?? null;
        this.grainSizeD30 = data.grainSizeD30 ?? null;
        this.grainSizeD60 = data.grainSizeD60 ?? null;
        this.k0CalcMethod = data.k0CalcMethod ?? null;
        this.coefficientOfLateralEarthPressureAtRestK0 = data.coefficientOfLateralEarthPressureAtRestK0 ?? null;
        this.notes = data.notes ?? null;

    }

    get gravitationalAccelerationG() {
        return this.geoSection?.gravitationalAccelerationG ?? null;
    }

    get densityOfWaterRoW() {
        return this.geoSection?.densityOfWaterRoWGeoTypesPurposes ?? null;
    }

    get unitWeightOfWaterGamaW() {
        return this.geoSection?.unitWeightOfWaterGamaWGeoTypesPurposes ?? null;
    }

}
